import { AuthProvider as LibAuthProvider, useAuthContext } from '@helios/frontend-auth';
import React, { useEffect } from 'react';
import { PREVENT_LIVE_UPDATE_RELOAD_KEY } from '../../../hooks/_app/useNativeAppListener';
import { requestInitialAchievements } from '../../../utils/achievementPolling';

const AppAuthSideEffects: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuthContext();

  useEffect(() => {
    if (isAuthenticated) {
      localStorage.setItem(PREVENT_LIVE_UPDATE_RELOAD_KEY, 'false');
      requestInitialAchievements();
    }
  }, [isAuthenticated]);

  return <>{children}</>;
};

const AuthProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return (
    <LibAuthProvider>
      <AppAuthSideEffects>{children}</AppAuthSideEffects>
    </LibAuthProvider>
  );
};

export default AuthProvider;
